import { studentHomeApi, type WeeklyLearningSummary } from '@mathflat/domain/StudentHome'
import { endOfWeek, format, getMonth, startOfWeek, subWeeks } from 'date-fns'
import { makeAutoObservable, runInAction } from 'mobx'
import { nanoid } from 'nanoid'

/** 주간 학습 요약 (Basic + Parent 공통) */
export default class WeeklyHistoryService {
  weeklyHistories: WeeklyLearningSummary[] = []
  private _currentWeekHistory: WeeklyLearningSummary | null = null
  private _isReady = false

  constructor() {
    makeAutoObservable(this)
  }

  get isReady() {
    return this._isReady
  }
  get currentWeekHistory() {
    return this._currentWeekHistory
  }
  get totalProblemCount() {
    return this._currentWeekHistory?.totalCount ?? 0
  }
  get correctRate() {
    return this._currentWeekHistory?.rate ?? 0
  }

  get chartData() {
    return this.weeklyHistories.map(
      ({ date, week, totalCount, rate, weekStartDate, weekEndDate }, idx) => ({
        label:
          idx !== this.weeklyHistories.length - 1
            ? `${getMonth(new Date(date)) + 1}월 ${week}째주`
            : '이번주',
        weekStartDate: format(new Date(weekStartDate), 'yyyy.MM.dd'),
        weekEndDate: format(new Date(weekEndDate), 'MM.dd'),
        barData: totalCount,
        dotData: rate,
        id: nanoid(),
      }),
    )
  }

  reset() {
    this.weeklyHistories = []
    this._currentWeekHistory = null
    this._isReady = false
  }

  async load(studentId: string) {
    const today = new Date()
    const startOfThisWeek = startOfWeek(today, { weekStartsOn: 1 })
    const endOfThisWeek = endOfWeek(today, { weekStartsOn: 1 })
    const startDate = subWeeks(startOfThisWeek, 3)

    const data = await studentHomeApi.getWeeklyLearningSummaries(studentId, {
      startDate: format(startDate, 'yyyy-MM-dd'),
      endDate: format(endOfThisWeek, 'yyyy-MM-dd'),
    })

    runInAction(() => {
      this.weeklyHistories = data
      this._currentWeekHistory = data.length > 0 ? data[data.length - 1] : null
      this._isReady = true
    })
  }
}
